import { useLanguage } from "@/contexts/LanguageContext"

const StatsSection = () => {
  const { t } = useLanguage()
  const stats = [
    { value: "100", suffix: "+", label: t('stats.students') },
    { value: "9", suffix: "", label: t('stats.domains') },
    { value: "72", suffix: "h", label: t('stats.contact') },
  ]
  return (
    <section id="stats" className="py-24 md:py-32 bg-je-white">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5">01 — Chiffres</span>
            <h2 className="text-section-title font-serif font-medium text-je-black mt-4 text-balance">
              {t('stats.title')}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-gray-dark text-pretty">{t('stats.subtitle')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-je-navy/15">
          {stats.map((s, i) => (
            <div key={i} className={`scroll-reveal py-12 md:py-16 ${i > 0 ? 'md:border-l border-je-navy/15 md:pl-12' : ''} border-b border-je-navy/15 md:border-b-0`}>
              <div className="flex items-baseline gap-1 mb-6">
                <span className="font-serif text-7xl md:text-8xl font-medium text-je-black tracking-tight tabular-nums">{s.value}</span>
                <span className="font-serif text-4xl text-je-red">{s.suffix}</span>
              </div>
              <div className="font-mono text-xs uppercase tracking-[0.18em] text-je-gray-dark">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default StatsSection
